import qaApi from "@/services/api/qa";

const state = {
  report: null,
  isLoading: false,
};

const getters = {
  report: (state) => state.report,
  loading: (state) => state.isLoading,
};

const actions = {
  async loadReport({ commit }) {
    commit("loading", true);
    const result = await qaApi.report();
    commit("setReport", result.data);
    commit("loading", false);
  },
};

const mutations = {
  setReport(state, report) {
    state.report = report;
  },
  loading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
